document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector('#picture-container')) return;
  const templates = Array.from(document.querySelectorAll(".js-picture"));
  if (templates.length === 0) return;
  const randomTemplate = templates[Math.floor(Math.random() * templates.length)];
  const content = randomTemplate.content.cloneNode(true);
  const container = document.getElementById("picture-container");
  container.appendChild(content);
}, false);
